import { jsx as _jsx } from "react/jsx-runtime";
import { cva } from 'class-variance-authority';
import { cn } from '@/shared/lib/cn';
const alertVariants = cva('relative w-full rounded-md border px-4 py-3 text-sm', {
    variants: {
        variant: {
            default: 'border-border bg-card text-foreground',
            info: 'border-[color:var(--unity-color-info)]/30 bg-[color:var(--unity-color-info)]/10 text-foreground',
            destructive: 'border-destructive/40 bg-destructive/10 text-destructive',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});
export function Alert({ className, variant, ...props }) {
    return (_jsx("div", { role: "status", className: cn(alertVariants({ variant }), className), ...props }));
}
export function AlertTitle({ className, ...props }) {
    return (_jsx("h3", { className: cn('mb-1 font-medium leading-none tracking-tight', className), ...props }));
}
export function AlertDescription({ className, ...props }) {
    return (_jsx("p", { className: cn('text-sm text-muted-foreground', className), ...props }));
}
